<template>
  <v-container fluid>
    <v-card>
      <v-container class="ma-0 pa-0" fluid>
        <v-container grid-list-xs fluid class="mb-0 pb-0" style="padding: 5px;">
          <v-layout row style="padding: 10px;">
            <v-layout>
              <v-flex md3 style="padding: 15px 5px;">
                <v-menu
                  ref="dateFromMenu"
                  :close-on-content-click="false"
                  v-model="dateFromMenu"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="dateFrom"
                    label="Date From"
                    prepend-inner-icon="event"
                    outline
                    readonly
                  ></v-text-field>

                  <v-date-picker
                    ref="picker"
                    v-model="dateFrom"
                    :max="maxDate"
                    min="1950-01-01"
                    @input="dateFromMenu = false"
                    @change="checkDateFrom($event)"
                  ></v-date-picker>
                </v-menu>
              </v-flex>

              <!-- <v-flex md2 style="padding: 15px 5px;">
                <v-menu
                  ref="timeFromMenu"
                  :close-on-content-click="false"
                  v-model="timeFromMenu"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="timeFrom"
                    @click="clockMode = 'timeFrom'"
                    label="Time From"
                    prepend-inner-icon="event"
                    outline
                    readonly
                  ></v-text-field>

                  <v-time-picker v-model="timeFrom" format="24hr">
                    <v-btn flat color="amber" @click="cancelTimePicker">Cancel</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn flat color="amber" @click="timeFromMenu = false;">DONE</v-btn>
                  </v-time-picker>
                </v-menu>
              </v-flex> -->

              <!-- <v-flex md2 style="padding: 15px 5px;">
                <v-menu
                  ref="dateToMenu"
                  :close-on-content-click="false"
                  v-model="dateToMenu"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="dateTo"
                    label="Date To"
                    prepend-inner-icon="event"
                    outline
                    readonly
                  ></v-text-field>

                  <v-date-picker
                    ref="picker"
                    v-model="dateTo"
                    :max="new Date().toISOString().substr(0, 10)"
                    :min="dateFrom"
                    @input="dateToMenu = false"
                    @change="checkDateTo($event)"
                  ></v-date-picker>
                </v-menu>
              </v-flex> -->

              <!-- <v-flex md2 style="padding: 15px 5px;">
                <v-menu
                  ref="timeToMenu"
                  :close-on-content-click="false"
                  v-model="timeToMenu"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="timeTo"
                    @click="clockMode = 'timeTo'"
                    label="Time To"
                    prepend-inner-icon="event"
                    outline
                    readonly
                  ></v-text-field>
                  <v-time-picker v-model="timeTo" format="24hr">
                    <v-btn flat color="amber" @click="cancelTimePicker">Cancel</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn flat color="amber" @click="timeToMenu = false;">DONE</v-btn>
                  </v-time-picker>
                </v-menu>
              </v-flex> -->
              <v-spacer></v-spacer>
            </v-layout>
            <!-- <v-flex md6>
              <v-text-field
                ref="form"
                class="mr-1"
                prepend-icon="search"
                label="Search"
                v-model="searchItem"
                clearable
                hide-details
              ></v-text-field>
            </v-flex>-->
            <v-spacer></v-spacer>
            <!-- <v-select
            v-model="theTableStyle"
            :items="tableItems"
            prepend-icon="table_chart"
            label="Type of Table"
            style="width: 0.10%;"
            ></v-select>-->
            <v-btn fab dark small color="amber darken-2" @click="getData">
              <v-icon dark>play_arrow</v-icon>
            </v-btn>
            <v-tooltip top>
              <v-btn
                fab
                dark
                small
                color="amber darken-2"
                slot="activator"
                @click="downloadExcel()"
              >
                <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                  <path
                    fill="#ffffff"
                    d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M15.8,20H14L12,16.6L10,20H8.2L11.1,15.5L8.2,11H10L12,14.4L14,11H15.8L12.9,15.5L15.8,20M13,9V3.5L18.5,9H13Z"
                  />
                </svg>
              </v-btn>
              <span>Download Excel File</span>
            </v-tooltip>
            <refresh-button @refresh="refreshTable()"></refresh-button>
          </v-layout>
          <!-- <v-container grid-list-lg fluid style="padding: 0px;" class="pt-3">
          </v-container>-->
          <v-layout row>
            <v-flex md2 style="padding: 0 15px 0 15px">
              <v-select v-model="filterVehicle" :items="filterVehicles" label="Store Name"></v-select>
            </v-flex>
            <!-- <v-flex md2 style="padding: 0 15px">
              <v-select v-model="filterRoute" :items="filterRoutes" label="Route"></v-select>
            </v-flex>
            <v-flex md2>
              <v-select v-model="filterBound" :items="filterBounds" label="Bound"></v-select>
            </v-flex> -->
          </v-layout>
        </v-container>
        <!-- Filter -->
        <!-- <v-divider></v-divider> -->
        <!-- <v-layout row>
          <v-flex sm4 md4>
            <v-btn flat @click="openFilterExpansion">
              <v-icon class="mr-3">{{ openFilter ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</v-icon>
              <span>Filter {{ title }}</span>
            </v-btn>
          </v-flex>
        </v-layout>-->
        <filter-panel :openFilter="openFilter">
          <v-flex md4 style="padding-right: 15px">
            <v-select
              v-model="filterCompany"
              :items="filterCompanies"
              label="Origin"
              solo
              clearable
            ></v-select>
          </v-flex>
          <v-flex md4>
            <v-select
              v-model="filterSubCompany"
              :items="filterSubCompanies"
              label="Destination"
              solo
              clearable
            ></v-select>
          </v-flex>
        </filter-panel>
        <v-divider></v-divider>
        <!-- For filter -->

        <v-data-table :headers="headers" :items="items" hide-actions disable-initial-sort>
          <template slot="headers" slot-scope="props">
            <tr>
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="[
                    'column sortable', 
                    header.value === queryParams.order ? 'active' : '', 
                    'text-xs-'+header.align
                  ]"
              >
                <span>{{ header.text.toUpperCase() }}</span>
              </th>
            </tr>
          </template>
          <template slot="items" slot-scope="props">
            <!-- <td class="text-xs-center" data-v-01442dcc data-v-ae22ea74>{{ props.index + 1}}</td> -->
            <td
              data-v-ae22ea74
              class="text-xs-center no-wrap"
            >{{ props.item.date_from === "Invalid date" ? "--" : $dateFormat(props.item.date_from, "YYYY-MM-DD") }}</td>
            <td
              class="text-xs-center no-wrap"
            >{{ props.item.date_to === "Invalid date" ? "--" : $dateFormat(props.item.date_to, "YYYY-MM-DD") }}</td>
            <td
              class="text-xs-left text-uppercase"
            >{{ props.item.vehicle_no === "null" ? "--" : props.item.vehicle_no }}</td>
            <!-- <td class="text-xs-left text-uppercase">{{ props.item.from }}</td> -->
            <!-- <td class="text-xs-left text-uppercase">{{ props.item.to }}</td> -->
            <!-- <td class="text-xs-right">{{ props.item.total_trips }}</td> -->
            <!-- <td class="text-xs-right">{{ props.item.day_run }}</td> -->
            <td class="text-xs-right">{{ props.item.gross_sales.toFixed(2) }}</td>
            <!-- <td class="text-xs-right">{{ props.item.cash.toFixed(2) }}</td>
            <td class="text-xs-right">{{ props.item.card.toFixed(2) }}</td>
            <td class="text-xs-right">{{ props.item.reservation.toFixed(2) }}</td> -->
          </template>
          <!-- <template v-if="items.length !== 0" slot="footer">
            <td class="text-xs-center font-weight-bold">Total:</td>
            <td class="text-xs-center"></td>
            <td class="text-xs-center"></td>
            <td class="text-xs-center"></td>
          </template>-->
        </v-data-table>
      </v-container>
    </v-card>
  </v-container>
</template>

<script>
import Services from "@/services/SubCompanyServices";
import XLSX from "xlsx";
import dateRangeFunctions from "@/utils/dateRangeFunctions";
const now = new Date();

export default {
  data() {
    return {
      //For filter
      openFilter: false,
      filterCompanies: [],
      filterCompany: null,
      filterSubCompanies: [],
      filterSubCompany: null,
      filterBound: null,
      filterVehicle: null,
      filterRoute: null,
      filterBounds: [
        {
          text: "ALL",
          value: null
        }
      ],
      filterVehicles: [
        {
          text: "ALL",
          value: null
        }
      ],
      filterRoutes: [
        {
          text: "ALL",
          value: null
        }
      ],
      title: "Sales Report",
      timeOut: null,
      theTableStyle: false,
      headers: [
        // { text: "#", align: "center", sortable: false },
        // Add your Header BELOW
        {
          text: "Date From",
          align: "center",
          sortable: false
        },
        {
          text: "Date To",
          align: "center",
          sortable: false
        },
        {
          text: "Store Name",
          align: "left",
          sortable: false
        },
        // {
        //   text: "From",
        //   align: "left",
        //   sortable: false
        // },
        // {
        //   text: "To",
        //   align: "left",
        //   sortable: false
        // },
        // {
        //   text: "Total Trips",
        //   align: "right",
        //   sortable: false
        // },
        // {
        //   text: "Days Run",
        //   align: "right",
        //   sortable: false
        // },
        {
          text: "Gross Sales (PHP)",
          align: "right",
          sortable: false
        },
        // {
        //   text: "Cash (PHP)",
        //   align: "right",
        //   sortable: false
        // },
        // {
        //   text: "Card (PHP)",
        //   align: "right",
        //   sortable: false
        // },
        // {
        //   text: "Reservation (PHP)",
        //   align: "right",
        //   sortable: false
        // }
      ],
      items: [],
      totalItems: {},
      queryParams: {
        search: "",
        company_id: null,
        sub_company_id: null,
        date_from: null,
        date_to: null
      },
      menu: false,
      menu1: false,
      clockMode: "",
      dateFromMenu: false,
      dateToMenu: false,
      timeFromMenu: false,
      timeToMenu: false,
      timeFrom: "00:00",
      timeTo: "23:59",
      timeOut: null,
      dateFrom: this.$dateFormat(now, "YYYY-MM-DD"),
      dateTo: this.$dateFormat(now, "YYYY-MM-DD"),
      maxDate: this.$dateFormat(now, "YYYY-MM-DD")

    };
  },
  computed: {
    searchItem: {
      get() {},
      set(value) {
        clearTimeout(this.timeOut);
        this.timeOut = setTimeout(() => {
          this.search(value);
        }, 500);
      }
    }
  },
  //For filter
  watch: {
    filterCompany: async function() {
      if (
        this.filterCompany !== null &&
        this.filterCompany !== undefined &&
        this.filterCompany !== ""
      ) {
        this.queryParams.offset = 0;
        this.queryParams.company_id = this.filterCompany;
        this.getData();
      } else {
        this.queryParams.offset = 0;
        this.queryParams.company_id = null;
        this.getData();
      }
    },
    filterSubCompany: async function() {
      if (
        this.filterSubCompany !== null &&
        this.filterSubCompany !== undefined &&
        this.filterSubCompany !== ""
      ) {
        this.queryParams.offset = 0;
        this.queryParams.sub_company_id = this.filterSubCompany;
        this.getData();
      } else {
        this.queryParams.offset = 0;
        this.queryParams.sub_company_id = null;
        this.getData();
      }
    },
    filterBound: async function() {
      if (
        this.filterBound !== null &&
        this.filterBound !== undefined &&
        this.filterBound !== "" &&
        this.filterBound !== false
      ) {
        this.queryParams.offset = 0;
        this.queryParams.bound_id = this.filterBound;
        this.getData();
      } else {
        this.queryParams.offset = 0;
        this.queryParams.bound_id = null;
        this.getData();
      }
    },
    filterVehicle: async function() {
      if (
        this.filterVehicle !== null &&
        this.filterVehicle !== undefined &&
        this.filterVehicle !== "" &&
        this.filterVehicle !== false
      ) {
        this.queryParams.offset = 0;
        this.queryParams.vehicle_id = this.filterVehicle;
        this.getData();
      } else {
        this.queryParams.offset = 0;
        this.queryParams.vehicle_id = null;
        this.getData();
      }
    },
    filterRoute: async function() {
      if (
        this.filterRoute !== null &&
        this.filterRoute !== undefined &&
        this.filterRoute !== "" &&
        this.filterRoute !== false
      ) {
        this.queryParams.offset = 0;
        this.queryParams.route_id = this.filterRoute;
        this.getData();
      } else {
        this.queryParams.offset = 0;
        this.queryParams.route_id = null;
        this.getData();
      }
    }
  },
  created: function() {
    this.getFilter();
  },
  methods: {
   async checkDateFrom(event) {
    console.log(this.dateFrom);
      this.dateTo = await dateRangeFunctions.checkFrom7DayStrict(
        
        event,
        this.dateFrom,
        this.dateTo
      );
    },
   async checkDateTo(event) {
      this.dateFrom = await dateRangeFunctions.checkTo7DayStrict(
        event,
        this.dateFrom,
        this.dateTo
      );
    },             
    search(data) {
      this.queryParams.search = data;
      this.queryParams.offset = 0;
      this.queryParams.limit = 10;
      this.getData();
    },
    async getFilter() {
      this.queryParams.company_id = this.$store.state.company.id;
      this.queryParams.sub_company_id = this.$store.state.subcompany.id;

      //Bound items
      let responseBound = (await Services.getBounds(this.queryParams)).data;
      let boundItem = responseBound.data;
      for (let b = 0; b < boundItem.length; b++) {
        let body = {
          text: boundItem[b].name.toUpperCase(),
          value: boundItem[b].bound_id
        };
        this.filterBounds.push(body);
      }

      //Vehicle items
      let responseVehicle = (await Services.getVehicles(this.queryParams)).data;
      let vehicleItem = responseVehicle.data;
      for (let b = 0; b < vehicleItem.length; b++) {
        let body = {
          text: vehicleItem[b].vehicle_no.toUpperCase(),
          value: vehicleItem[b].vehicle_id
        };
        this.filterVehicles.push(body);
      }

      //Route items
      let responseRoute = (await Services.getRoutes(this.queryParams)).data;
      let routeItem = responseRoute.data;
      for (let b = 0; b < routeItem.length; b++) {
        let body = {
          text: routeItem[b].name.toUpperCase(),
          value: routeItem[b].id
        };
        this.filterRoutes.push(body);
      }
    },
    async getData() {
      this.items = [];
      // Start Loading
      this.$store.dispatch("startLoading");

      this.queryParams.date_from = this.dateFrom + " " + "00:00:00";
      this.queryParams.date_to = this.dateFrom + " " + "23:59:59";
      this.queryParams.company_id = this.$store.state.company.id;
      this.queryParams.sub_company_id = this.$store.state.subcompany.id;

      try {
        // Query Data
        let response = (await Services.getSalesReport(this.queryParams)).data;

        // Assign the reponse data to items to be display on table
        this.items = response.data;
        // this.totalItems = response.total;
      } catch (error) {
        if (!error.response) {
          if (!this.$isEmpty(this.$store.state.employee)) {
            this.$infoBar({
              type: "error",
              text: "No network or server connection"
            });
          } else {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        } else {
          console.log(error.response.status);
          if (error.response.status === 403) {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        }
      }
      this.$store.dispatch("endLoading");
    },
    refreshTable() {
      this.getData();
      this.filterVehicle = null;
      this.filterBound = null;
      this.filterRoute = null;
    },
    //For filter
    async setFilterCompanies() {
      this.$store.state.companies.map(item => {
        let body = {
          text: item.name.toUpperCase(),
          value: item.id
        };
        this.filterCompanies.push(body);
      });
    },
    async setFilterSubCompanies() {
      this.$store.state.sub_companies.map(item => {
        let body = {
          text: item.name.toUpperCase(),
          value: item.id
        };
        this.filterSubCompanies.push(body);
      });
    },
    async openFilterExpansion() {
      this.openFilter = await !this.openFilter;
      await this.setFilterCompanies();
      await this.setFilterSubCompanies();
    },
    cancelTimePicker() {
      if (this.clockMode === "timeFrom") {
        this.timeFrom = "00:00";
        this.timeFromMenu = false;
      }
      if (this.clockMode === "timeTo") {
        this.timeTo = "23:59";
        this.timeToMenu = false;
      }
    },
    downloadExcel() {
      const wscols = [];
      const dataToDownload = [];
      const header = [];

      for (let i = 0; i < this.headers.length; i++) {
        header.push(this.headers[i].text.toUpperCase());
      }

      // header.shift();
      dataToDownload.push(header);

      for (let i = 0; i < this.headers.length; i++) {
        wscols.push({ wch: 15 });
      }
      //theItem.push(this.items[e].
      for (let e = 0; e < this.items.length; e++) {
        const theItem = [];
        theItem.push(
          this.items[e].date_from === "Invalid date"
            ? "--"
            : this.$dateFormat(this.items[e].date_from, "YYYY-MM-DD")
        );
        theItem.push(
          this.items[e].date_to === "Invalid date"
            ? "--"
            : this.$dateFormat(this.items[e].date_to, "YYYY-MM-DD")
        );
        theItem.push(
          this.items[e].vehicle_no !== "null"
            ? this.items[e].vehicle_no.toUpperCase()
            : "--"
        );
        // theItem.push(
        //   this.items[e].from ? this.items[e].from.toUpperCase() : "--"
        // );
        // theItem.push(this.items[e].to ? this.items[e].to.toUpperCase() : "--");
        // theItem.push(this.items[e].total_trips);
        // theItem.push(this.items[e].day_run);
        theItem.push(
          this.items[e].gross_sales
            ? parseFloat(this.items[e].gross_sales.toFixed(2))
            : "--"
        );
        // theItem.push(
        //   this.items[e].cash ? parseFloat(this.items[e].cash.toFixed(2)) : "--"
        // );
        // theItem.push(
        //   this.items[e].card ? parseFloat(this.items[e].card.toFixed(2)) : "--"
        // );
        // theItem.push(
        //   this.items[e].reservation
        //     ? parseFloat(this.items[e].reservation.toFixed(2))
        //     : "--"
        // );

        dataToDownload.push(theItem);
      }

      for (let e = 0; e < 2; e++) {
        const theItem_2 = [];

        theItem_2.push("");
        theItem_2.push("");
        theItem_2.push("");
        theItem_2.push("");
        theItem_2.push("");
        theItem_2.push("");
        theItem_2.push("");
        theItem_2.push("");
        theItem_2.push("");

        dataToDownload.push(theItem_2);
      }

      // const totalItems = [
      //   "TOTAL",
      //   "",
      //   // this.totalItems.control_no,
      //   this.totalItems.total_trips,
      //   "",
      //   ""
      // ];

      // dataToDownload.push(totalItems);

      // don't delete any codes after this comment got it?!

      var wsrows = [];

      var ws = XLSX.utils.aoa_to_sheet(dataToDownload, { cellDates: true });
      var wb = XLSX.utils.book_new();
      var wsname = "SheetJS";

      var fmt = "#,##0.00";

      var range = XLSX.utils.decode_range(ws["!ref"]);
      for (var e = range.s.r + 1; e <= range.e.r; ++e) {
        for (var C = range.s.c; C <= range.e.c; ++C) {
          var ref = XLSX.utils.encode_cell({ r: e, c: C });
          if (!ws[ref]) continue;
          if (ws[ref].t !== "n") continue;
          ws[ref].z = fmt;

          if (header[C] === "DAYS RUN") ws[ref].z = "#,##0";
          if (header[C] === "TOTAL TRIPS") ws[ref].z = "#,##0";
        }
      }

      XLSX.utils.book_append_sheet(wb, ws);

      ws["!cols"] = wscols;
      ws["!rows"] = wsrows;

      wb.Props = {
        Title: this.title,
        Subject: this.title,
        Author: "Developer of Journeytech",
        Company: "Journeytech",
        Category: "Reports"
      };

      if (!wb.Workbook) wb.Workbook = { Sheets: [], WBProps: {} };
      if (!wb.Workbook.WBProps) wb.Workbook.WBProps = {};
      wb.Workbook.WBProps.filterPrivacy = true;

      var filenames = [
        [this.title + ".xlsx"],
        [this.title + ".xlsm"],
        [this.title + ".xlsb"],
        [this.title + ".xlam"],
        [this.title + ".biff8.xls", { bookType: "xls" }],
        [this.title + ".biff5.xls", { bookType: "biff5" }],
        [this.title + ".biff2.xls", { bookType: "biff2" }],
        [this.title + ".xml.xls", { bookType: "xlml" }],
        [this.title + ".xla"],
        [this.title + ".ods"],
        [this.title + ".fods"],
        [this.title + ".csv"],
        [this.title + ".txt"],
        [this.title + ".slk"],
        [this.title + ".eth"],
        [this.title + ".htm"],
        [this.title + ".dif"],
        [this.title + ".dbf", { sheet: "Hidden" }],
        [this.title + ".rtf"],
        [this.title + ".prn"]
      ];
      var OUT = ["base64", "binary", "string", "array"];
      if (typeof Buffer !== "undefined") OUT.push("buffer");
      filenames.forEach(function(r) {
        XLSX.writeFile(wb, r[0], r[1]);
        if (typeof process !== "undefined") XLSX.readFile(r[0]);

        var ext = (r[1] && r[1].bookType) || r[0].split(".")[1];
        ext = { htm: "html" }[ext] || ext;
        OUT.forEach(function(type) {
          if (
            type === "string" &&
            [
              "xlsx",
              "xlsm",
              "xlsb",
              "xlam",
              "biff8",
              "biff5",
              "biff2",
              "xla",
              "ods",
              "dbf"
            ].indexOf(ext) > -1
          )
            return;
          if (
            type === "array" &&
            ["xlsx", "xlsm", "xlsb", "xlam", "ods"].indexOf(ext) > -1 &&
            typeof Uint8Array === "undefined"
          )
            return;
          var datout = XLSX.write(wb, {
            type: type,
            bookType: ext,
            sheet: (r[1] && r[1].sheet) || null
          });
          XLSX.read(datout, { type: type });
          if (type === "array") console.log(ext, datout);
        });
      });
    }
  }
};
</script>

<style scoped>
.table-controls {
  padding: 0 !important;
}
table.v-table td,
th {
  box-shadow: 1px 0px 0px 0px #eee;
}
table.v-table tbody tr {
  cursor: pointer !important;
}
.current-row {
  background-color: #ddd;
}
.row-active {
  box-shadow: 4px -1px 0px 0px rgb(76, 175, 80) inset;
}
.row-inactive {
  color: rgb(244, 67, 54);
  box-shadow: 4px 0px 0px 0px rgb(244, 67, 54) inset;
}
table.v-table td,
th {
  height: 30px !important;
  padding: 0px 5px 0px 5px !important;
}
table.v-table thead tr:not(.v-datatable__progress) {
  height: 30px;
}
table.v-table th {
  padding-left: 5px !important;
  padding-right: 5px !important;
}
.scrolling-wrapper {
  overflow-x: hidden;
  height: 400px;
  overflow-y: scroll;
  white-space: nowrap;
}
</style>